export default {
  setLoading(state, value) {
    state.isLoading = value;
  },
  setCompanyList(state, data) {
    state.companyList = data;
  },
};
